import { Constants } from "./constants";

export const ResultTypesMap = new Map<string, string>([
  [Constants.score_result_type.absent, "ABS"],
  [Constants.score_result_type.bitch_in_season, "AIS"],
  [Constants.score_result_type.excused, "EX"],
  [Constants.score_result_type.disqualified, "DQ"],
  [Constants.score_result_type.not_qualified, "NQ"],
  [Constants.score_result_type.scratched, "SCR"],
  [Constants.score_result_type.conflict, "Conflict"],
  [Constants.score_result_type.non_regular, "NR"],
]);
